module.exports = __webpack_public_path__ + "static/media/Certificate.24f2bbe2.svg";